import React from "react";
import {FullProgress} from "../fullProgress/FullProgress";
import {CapacityProgress, SlotBookedInfo, SlotContent, Wrapper} from "./SlotCell.styles";
import {UserOutlined} from "@ant-design/icons";
export const SlotCell = ({
    limit,
    totalBooked,
    disabled = false,
    mode = "normal",
    hover = true,
    children
}) => {
    if (children !== undefined) {
        return <Wrapper disabled={disabled}>{children}</Wrapper>;
    }

    return (
        <Wrapper disabled={disabled} mode={mode} hover={hover}>
            <CapacityProgress>
                <FullProgress
                    progress={limit && totalBooked && limit > 0 ? (totalBooked / limit) * 100 : 0}
                />
            </CapacityProgress>
            <SlotContent mode={mode}>
                {totalBooked || 0}
                <SlotBookedInfo>
                    {limit || 0}
                    <UserOutlined />
                </SlotBookedInfo>
            </SlotContent>
        </Wrapper>
    );
};
